import { SelectedOrderModel } from './selected-order.model';
import * as SelectedOrderActions from './selected-order.actions';
import { createReducer, on, Action } from '@ngrx/store';

const initialState: SelectedOrderModel = new SelectedOrderModel();

const reducer = createReducer(
  initialState,
  on(SelectedOrderActions.setSelectedOrderData, (state, { dossierNumber }) => ({ ...state, dossierNumber })),
  on(SelectedOrderActions.setSelectedOrderFlightIdentifier, (state, { flightDetailsIdentifier }) => ({ ...state, flightDetailsIdentifier }))
);

export function selectedOrderReducer(state: SelectedOrderModel, action: Action) {
  return reducer(state, action);
}
